export interface ApiState<T> {
    loading: boolean;
    success: boolean;
    error: Error | null;
    data: T | undefined;
}

export const defaultApiState: ApiState<any> = {
    loading: false,
    success: false,
    error: null,
    data: undefined
};

export const ApiStatus = {
    LOADING: { loading: true, data: undefined },
    SUCCESS: { success: true }
}

export interface Paginate<T> {
    items: T[];
    totalCount: number;
}
